export default __webpack_public_path__ + "assets/front/scss/editorial.679fe33b886da6209e20f3c311fac3eb.css";